import React, { useMemo } from 'react'
import AppSentinelsMappingForm from './AppSentinelsMappingForm';
import AppSentinelsCredentialForm from './AppSentinelsCredentialForm';
import GenericPullConfigListing from '../GenericPullConfigListing';

export default function AppSentinelsConfigListing(props) {

    const columns = useMemo(() => [{
            title: "Organization",
            dataIndex: "organization",
            width: 200
        },
        {
            title: "Application",
            dataIndex: "application",
            width: 200
        },
    ], [])

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            extraColumns={columns}
            MappingForm={AppSentinelsMappingForm}
            CredentialsForm={AppSentinelsCredentialForm}
        />
    )
}